// src/supabase.js
import { createClient } from '@supabase/supabase-js'

const SUPABASE_URL      = import.meta.env.VITE_SUPABASE_URL
const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY

if (!SUPABASE_URL || !SUPABASE_ANON_KEY) {
  console.error('❌ Variables VITE_SUPABASE_URL ou VITE_SUPABASE_ANON_KEY manquantes dans .env.local')
}

// Instance unique — jamais recréée
export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession:     true,
    autoRefreshToken:   true,
    detectSessionInUrl: false,  // désactivé pour éviter les conflits au démarrage
    storageKey:         'solstice-auth',
    storage:            window.localStorage,
    // Web Lock désactivé — nécessaire : quand il est activé, tous les appels REST attendent
    // le lock JWT (exclusif), bloquant le chargement initial des données si un refresh est en cours.
    // Le bug de démarrage est corrigé dans AuthContext.jsx via Promise.race 5s.
    lock: (name, acquireTimeout, fn) => fn(),
  },
  realtime: {
    params: {
      eventsPerSecond: 1,
    },
    // Backoff plus conservateur : démarre à 3s (au lieu de 500ms) — réduit
    // la compétition réseau entre WebSocket et les appels REST (save, etc.)
    reconnectAfterMs: (tries) => Math.min(3000 * Math.pow(2, tries), 60000),
  },
})

export default supabase
